import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Industries/SaaSPlatform.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/JsonLd.tsx");
